import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class EmployeeAttandanceDetailsReportDto implements IEmployeeAttandanceDetailsReportDto {
    employee!: EmployeeSummaryDto;
    eventDate!: Date;
    inTime!: Date | undefined;
    outTime!: Date | undefined;
    dayFlag!: string | undefined;
    dailyTime!: string | undefined;
    finalTime!: string | undefined;
    workTime!: string | undefined;
    presentTime!: string | undefined;
    lunchTime!: string | undefined;
    absentTime!: string | undefined;
    earlyTime!: string | undefined;
    lateTime!: string | undefined;
    otTime!: string | undefined;
    shortLeaveTime!: string | undefined;
    pCount!: number;
    aCount!: number;
    hlCount!: number;
    hCount!: number;
    mtCount!: number;
    lCount!: number;
    lateCount!: number;
    earlyCount!: number;
    otCount!: number;
    shortLeaveCount!: number;
    isManualAdjust!: boolean;
    isEditableLock!: boolean;
    manualAdjustId!: number;
    manualAdjustRemark!: string | undefined;
    remark!: string | undefined;

    constructor(data?: IEmployeeAttandanceDetailsReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.inTime = _data["inTime"] ? new Date(_data["inTime"].toString()) : <any>undefined;
            this.outTime = _data["outTime"] ? new Date(_data["outTime"].toString()) : <any>undefined;
            this.dayFlag = _data["dayFlag"];
            this.dailyTime = _data["dailyTime"];
            this.finalTime = _data["finalTime"];
            this.workTime = _data["workTime"];
            this.presentTime = _data["presentTime"];
            this.lunchTime = _data["lunchTime"];
            this.absentTime = _data["absentTime"];
            this.earlyTime = _data["earlyTime"];
            this.lateTime = _data["lateTime"];
            this.otTime = _data["otTime"];
            this.shortLeaveTime = _data["shortLeaveTime"];
            this.pCount = _data["pCount"];
            this.aCount = _data["aCount"];
            this.hlCount = _data["hlCount"];
            this.hCount = _data["hCount"];
            this.mtCount = _data["mtCount"];
            this.lCount = _data["lCount"];
            this.lateCount = _data["lateCount"];
            this.earlyCount = _data["earlyCount"];
            this.otCount = _data["otCount"];
            this.shortLeaveCount = _data["shortLeaveCount"];
            this.isManualAdjust = _data["isManualAdjust"];
            this.isEditableLock = _data["isEditableLock"];
            this.manualAdjustId = _data["manualAdjustId"];
            this.manualAdjustRemark = _data["manualAdjustRemark"];
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): EmployeeAttandanceDetailsReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAttandanceDetailsReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["inTime"] = this.inTime ? this.inTime.toISOString() : <any>undefined;
        data["outTime"] = this.outTime ? this.outTime.toISOString() : <any>undefined;
        data["dayFlag"] = this.dayFlag;
        data["dailyTime"] = this.dailyTime;
        data["finalTime"] = this.finalTime;
        data["workTime"] = this.workTime;
        data["presentTime"] = this.presentTime;
        data["lunchTime"] = this.lunchTime;
        data["absentTime"] = this.absentTime;
        data["earlyTime"] = this.earlyTime;
        data["lateTime"] = this.lateTime;
        data["otTime"] = this.otTime;
        data["shortLeaveTime"] = this.shortLeaveTime;
        data["pCount"] = this.pCount;
        data["aCount"] = this.aCount;
        data["hlCount"] = this.hlCount;
        data["hCount"] = this.hCount;
        data["mtCount"] = this.mtCount;
        data["lCount"] = this.lCount;
        data["lateCount"] = this.lateCount;
        data["earlyCount"] = this.earlyCount;
        data["otCount"] = this.otCount;
        data["shortLeaveCount"] = this.shortLeaveCount;
        data["isManualAdjust"] = this.isManualAdjust;
        data["isEditableLock"] = this.isEditableLock;
        data["manualAdjustId"] = this.manualAdjustId;
        data["manualAdjustRemark"] = this.manualAdjustRemark;
        data["remark"] = this.remark;
        return data; 
    }
}

export interface IEmployeeAttandanceDetailsReportDto {
    employee: EmployeeSummaryDto;
    eventDate: Date;
    inTime: Date | undefined;
    outTime: Date | undefined;
    dayFlag: string | undefined;
    dailyTime: string | undefined;
    finalTime: string | undefined;
    workTime: string | undefined;
    presentTime: string | undefined;
    lunchTime: string | undefined;
    absentTime: string | undefined;
    earlyTime: string | undefined;
    lateTime: string | undefined;
    otTime: string | undefined;
    shortLeaveTime: string | undefined;
    pCount: number;
    aCount: number;
    hlCount: number;
    hCount: number;
    mtCount: number;
    lCount: number;
    lateCount: number;
    earlyCount: number;
    otCount: number;
    shortLeaveCount: number;
    isManualAdjust: boolean;
    isEditableLock: boolean;
    manualAdjustId: number;
    manualAdjustRemark: string | undefined;
    remark: string | undefined;
}

